import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import { isEmpty } from 'lodash'

const ServiceSelectDialog = ({
  open,
  onClose,
  onSelect,
  services,
  titleId,
  emptyId,
}) => {
  const handleSelect = (service) => {
    onSelect(service)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <FormattedMessage id={titleId} />
      </DialogTitle>
      <DialogContent>
        {isEmpty(services) ? (
          <Typography variant="body2" color="text.secondary">
            <FormattedMessage id={emptyId} />
          </Typography>
        ) : (
          <List>
            {services.map((service) => (
              <ListItemButton key={service.id} onClick={() => handleSelect(service)}>
                <ListItemText primary={service.name} />
              </ListItemButton>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          <FormattedMessage id="app.actions.cancel.label" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ServiceSelectDialog
